import {defineRouting} from 'next-intl/routing';
 
export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en', 'es', 'ar', 'de', 'pt', 'fr'],
 
  // Used when no locale matches
  defaultLocale: 'en',
  
  // Don't add locale prefix to URLs
  localePrefix: 'never'
});